import { styled } from '@lichtblick/styled';
import { BorderRadius, Colors, Spacing } from '@lichtblick/theme';

export const Container = styled.div`
  position: relative;
  width: 100%;
`;

export const AutocompleteTrigger = styled.div<{ $isSmall: boolean }>`
  align-items: center;
  background: ${Colors.white};
  border: 1px solid ${Colors.blue[20]};
  border-radius: ${BorderRadius.Xs};
  box-sizing: border-box;
  display: flex;
  gap: var(--spacing-xxs);
  justify-content: space-between;
  min-height: 3rem;
  min-width: 8rem;
  overflow: hidden;
  padding: var(--spacing-xxs);
  padding-left: var(--spacing-xs);
  width: 100%;

  ${({ $isSmall }) =>
    $isSmall &&
    `
    min-height: 2rem;
    font-size: 0.875rem;
    min-width: 7rem;
  `}
`;

export const AutocompleteButton = styled.button`
  align-self: center;
  background: transparent;
  border: none;
  cursor: pointer;
  flex-shrink: 0;
`;

export const ChipContainer = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  gap: ${Spacing.Xxs};
  min-height: 1.5rem;
  min-width: 0;
`;

export const AutocompleteInput = styled.input`
  border: none;
  flex-grow: 1;
  font-size: 1rem;
  &:focus {
    outline: none;
  }
`;

export const AutocompleteOptions = styled.ul`
  border: 1px solid ${Colors.blue[20]};
  border-radius: ${BorderRadius.Xs};
  display: flex;
  flex-direction: column;
  margin: 0;
  min-width: 8rem;
  padding: 0;
  position: absolute;
  width: 100%;
  z-index: 1000;
`;

export const AutocompleteOption = styled.li`
  align-items: center;
  background: ${Colors.white};
  cursor: pointer;
  display: flex;
  gap: ${Spacing.Xxs};

  &[data-headlessui-state~='active'],
  &:hover {
    background: ${Colors.blue[20]};
    box-shadow: inset 0 0 0 1px ${Colors.blue[100]};
    outline: none;
  }

  &:focus {
    outline: none;
  }
`;

export const AutocompleteItem = styled.div<{ $isDeleted?: boolean; $isSelected: boolean }>`
  align-items: center;
  background-color: ${({ $isSelected }) => ($isSelected ? Colors.blue['50'] : 'transparent')};
  border-bottom: ${({ $isSelected }) => ($isSelected ? `1px solid ${Colors.white}` : 'none')};
  border-radius: ${BorderRadius.Xs};
  color: ${({ $isDeleted }) => ($isDeleted ? Colors.gray[50] : Colors.gray[100])};
  display: flex;
  height: auto;
  min-height: 3rem;
  opacity: ${({ $isDeleted }) => ($isDeleted ? 0.6 : 1)};
  padding: ${Spacing.Xxs};
  text-decoration: ${({ $isDeleted }) => ($isDeleted ? 'line-through' : 'none')};
  width: 100%;
`;
export const OptionsContainer = styled.div`
  max-height: 17rem;
  overflow-y: auto;
`;
export const AutocompleteItemTeam = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin: 0.5rem;
  width: 100%;
`;

export const AutocompleteItemInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const AutocompleteItemInfoBottom = styled.div`
  display: flex;
  flex-direction: row;
`;

export const AutocompleteItemInfoName = styled.p`
  color: ${Colors.gray[50]};
  margin: 0;
`;

export const AutocompleteItemInfoText = styled.p`
  color: ${Colors.gray[100]};
  font-size: 0.625rem;
  margin: 0;
`;
